import { _colors, getTheme } from '../themes';

export const getPageTheme = () => {
    const newTheme = getTheme();
    newTheme.components.Form = {
        itemMarginBottom: 0
    };
    return newTheme;
}

export const getCompanyNameTheme = () => {
    const newTheme = getTheme();
    newTheme.token.colorPrimary = _colors.black3;
    newTheme.token.fontSize = 36;
    newTheme.token.fontFamily = 'Mont';
    newTheme.token.fontWeightStrong = 900;
    newTheme.components = null;

    return newTheme;
}

export const getProductNameTheme = () => {
    const newTheme = getTheme();
    newTheme.token.fontSize = 24;
    newTheme.token.fontFamily = 'Montserrat';
    newTheme.token.fontWeightStrong = 700;

    return newTheme;
}